var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","timeout":2000,"color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('i',{class:_vm.icon,staticStyle:{"margin-right":"10px"}}),_vm._v(_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }